import { translations, locale } from '../i18n.js';

// Why: Reading translations.value here ensures components using this hook
// re-render when the locale changes (Preact signal tracking)
export function useI18n() {
  const dict = translations.value;

  function t(key, params = {}) {
    let text = key.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : null), dict);
    if (!text || typeof text !== 'string') return key;
    for (const [k, v] of Object.entries(params)) {
      text = text.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
    }
    return text;
  }

  return { t, locale: locale.value };
}
